/**
 * A type guard that checks if a value is null or undefined.
 * @param value
 * @returns `true` when not null or undefined. Otherwise `false`.
 */
export function isNotNullOrUndefined<T>(value: T | undefined | null): value is T {
	return !(value === null || typeof value === 'undefined');
}
